// extracted by mini-css-extract-plugin
module.exports = {"Main":"main_Main__3TLG_","infocards":"main_infocards__1MV9l","testcards":"main_testcards__1fGu_","mainTitle":"main_mainTitle__1UIp3"};